/* WildKind: rebuild the "About this item" bullets from the product's first
   description paragraph, so feature-card headings/emojis don't bleed into the
   summary on products with short intros. Safe + non-destructive: only runs on
   product pages that have .wk-about__list, and silently no-ops on any error. */
(function () {
  function toBullets(intro, list) {
    var parts = intro.split(/\.\s+/).map(function (s) { return s.trim(); }).filter(Boolean);
    if (!parts.length) return;
    list.innerHTML = '';
    parts.forEach(function (s) {
      var li = document.createElement('li');
      var last = s.slice(-1);
      li.textContent = (last === '.' || last === '!' || last === '?') ? s : s + '.';
      list.appendChild(li);
    });
  }
  async function run() {
    var list = document.querySelector('.wk-about__list');
    if (!list) return;
    try {
      var url = location.pathname.split('?')[0].replace(/\/$/, '') + '.js';
      var res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      var p = await res.json();
      var html = p.description || p.body_html || '';
      if (!html) return;
      var m = html.match(/<p[^>]*>([\s\S]*?)<\/p>/i);
      var raw = m ? m[1] : html;
      var tmp = document.createElement('div');
      tmp.innerHTML = raw;
      var intro = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      if (intro) toBullets(intro, list);
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
